export default {
  install(Vue) {
    Date.read = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return date;
      if (typeof date == "string" && date.indexOf("Z") == -1) date += "Z";
      return new Date(date);
    };

    Date.readIST = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return date;
      let d = Date.read(date);
      d.setMinutes(d.getMinutes() - 330);
      return d;
    };

    Date.readFileDate = (date) => {
      if (
        !date ||
        date == "0001-01-01T00:00:00" ||
        date == "Invalid Date" ||
        date.length < 14
      )
        return date;
      return new Date(
        date.substring(4, 6) +
          "/" +
          date.substring(6, 8) +
          "/" +
          date.substring(0, 4) +
          " " +
          date.substring(8, 10) +
          ":" +
          date.substring(10, 12) +
          ":" +
          date.substring(12, 14)
      );
    };

    Date.toLocal = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return date;
      let d = new Date(date);
      d.setMinutes(d.getMinutes() + 330);
      return d;
    };

    Date.showDay = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd mmm", 1);
    };

    Date.getDate = () => {
      return dateFormat(new Date(), "yyyy-mm-dd'T00:00:00Z'", 1);
    };

    Date.getLocalDate = () => {
      return dateFormat(Date.toLocal(new Date()), "yyyy-mm-dd'T00:00:00Z'", 1);
    };
    Date.ConvertToDateTime = (date, time) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      const formatedDate = dateFormat(Date.toLocal(date), "yyyy-mm-dd", 1);
      return `${formatedDate}T${time}`;
    };

    Date.showLocalFullSecond = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd mmm yyyy HH:MM:ss", 1);
    };

    Date.showLocalFull = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd/mm/yyyy hh:MM TT", 1);
    };
    Date.showLocalFullSec = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd/mm/yyyy hh:MM tt", 1);
    };
    Date.showLocalShort = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd mmm hh:MM TT", 1);
    };

    Date.showLocal = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "yyyy-mm-dd", 1);
    };
    Date.showLocalInd = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd-mm-yyyy", 1);
    };

    Date.toServerFull = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd/mm/yyyy HH:MM:ss", 1);
    };

    Date.toServerFullJoin = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd/mm/yyyy,HH:MM:ss", 1);
    };

    Date.toServer = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "dd/mm/yyyy", 1);
    };

    Date.showLocalMilitary = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(Date.toLocal(date), "yyyy-mm-dd HH:MM", 1);
    };

    Date.showMilitary = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(date, "yyyy-mm-dd HH:MM", 1);
    };

    Date.showTime = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(date, "hh:MM:ss TT");
    };

    Date.showTime24 = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(date, "HH:MM");
    };

    Date.showLocalTime = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      return dateFormat(date, "hh:MM:ss TT", 1);
    };

    Date.compare = (date1, date2) => {
      if (!date1 || date1 == "0001-01-01T00:00:00" || date1 == "Invalid Date")
        return 99999999;
      if (!date2 || date2 == "0001-01-01T00:00:00" || date2 == "Invalid Date")
        date2 = new Date();
      return parseInt((date2.getTime() - date1.getTime()) / 1000);
    };

    Date.addMins = (date, offset) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return date;
      let d = new Date(date);
      d.setMinutes(d.getMinutes() + offset);
      return d;
    };

    Date.addDays = (date, offset) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return date;
      let d = new Date(date);
      d.setDate(d.getDate() + offset);
      return d;
    };

    Date.addMonths = (date, offset) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return "";
      let d = new Date(date);
      d.setMonth(d.getMonth() + offset);
      return d;
    };

    Date.format = (date, format) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return "";
      let d = new Date(date);
      return dateFormat(d, format);
    };

    Vue.prototype.$showLocalDateFull = (date) => {
      if (!date) return "";
      return dateFormat(Date.toLocal(date), "dd mmm yyyy hh:MM TT", 1);
    };

    Vue.prototype.$getDate = (date) => {
      if (!date || date == "0001-01-01" || date == "Invalid Date") return "";
      return dateFormat(Date.toLocal(date), "yyyy-mm-dd", 1);
    };

    Vue.prototype.$getFDate = (date, format) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return "";
      return dateFormat(Date.toLocal(date), format, 1);
    };

    Vue.prototype.$getFOffsetDate = (date, offset, format) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return "";
      let d = Date.toLocal(date);
      d.setDate(d.getDate() + offset);
      return dateFormat(d, format, 1);
    };

    Vue.prototype.$getFOffsetMonth = (date, offset, format) => {
      if (!date || date == "01/01/0001" || date == "Invalid Date") return "";
      let d = Date.toLocal(date);
      d.setMonth(d.getMonth() + offset);
      return dateFormat(d, format, 1);
    };

    Vue.prototype.$dateformate = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      let d = Date.toLocal(date);
      return dateFormat(d, "dd mmm yyyy hh:MM TT", 1);
    };

    Vue.prototype.$dateformateUTC = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      let d = Date.toLocal(date);
      d.setMinutes(d.getMinutes() + 330);
      return dateFormat(d, "dd mmm yyyy hh:MM TT", 1);
    };

    Vue.prototype.$dateformateMilitary = (date) => {
      if (!date || date == "0001-01-01T00:00:00" || date == "Invalid Date")
        return "";
      let d = Date.toLocal(date);
      d.setMinutes(d.getMinutes() + 330);
      return dateFormat(d, "yyyy-mm-dd HH:MM", 1);
    };

    Vue.prototype.$dateCompare = (date1, date2) => {
      if (!date1 || date1 == "0001-01-01T00:00:00" || date1 == "Invalid Date")
        return 99999999;
      let d2 = null;
      if (!date2 || date2 == "0001-01-01T00:00:00" || date2 == "Invalid Date")
        d2 = new Date();
      else d2 = new Date(date2);
      let d1 = new Date(date1);
      return parseInt((d2.getTime() - d1.getTime()) / 1000);
    };

    Vue.prototype.$dateCompareUTC = (date1, date2) => {
      if (!date1 || date1 == "0001-01-01T00:00:00" || date1 == "Invalid Date")
        return 99999999;
      let d2 = null;
      if (!date2 || date2 == "0001-01-01T00:00:00" || date2 == "Invalid Date")
        d2 = new Date();
      else {
        d2 = Date.toLocal(date2);
      }
      let d1 = Date.toLocal(date1);
      return parseInt((d2.getTime() - d1.getTime()) / 1000);
    };

    Vue.prototype.$readDate = (strDate) => {
      let d = Date.parse(strDate);
      // d.setMinutes(d.getMinutes()+d.getTimezoneOffset()+330)
      return d;
    };

    Vue.prototype.$readDateTime = (strDate) => {
      let d = new Date(
        strDate.substring(4, 6) +
          "/" +
          strDate.substring(6, 8) +
          "/" +
          strDate.substring(0, 4) +
          " " +
          strDate.substring(8, 10) +
          ":" +
          strDate.substring(10, 12) +
          ":" +
          strDate.substring(12, 14)
      );
      // d.setMinutes(d.getMinutes()+d.getTimezoneOffset()+330)
      return d;
    };

    // Vue.prototype.$getDate = (date) => {

    // }

    // Vue.prototype.$displayDatetime = (date) => {
    //     if (!date || date == "0001-01-01T00:00:00" || d != "Invalid Date")
    //         return "";
    //     return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() + " " +
    //             var dd = today.getDate();
    //             var mm = today.getMonth() + 1; //January is 0!
    //             var yyyy = today.getFullYear();

    //             if (dd < 10) {
    //                 dd = '0' + dd
    //             }

    //             if (mm < 10) {
    //                 mm = '0' + mm
    //             }

    //             date = dd + '-' + mm + '-' + yyyy;
    //         }
    //         return date;
    //     }
    // }
  },
};

// const dateFormate1 = (date) => {
//     let date1 = new Date(date);
//     date1.setMinutes(date1.getMinutes()+330);
//     return date1.toLocaleString('en-GB');

// }

// const dateFormate5 = (date) => {
//     let date1 = new Date(date);
//     var options = { hour12: false };
//     return date1.toLocaleString('en-GB', options);

// }
// const dateFormate3 = (date) => {
//     let date1 = new Date(date);
//     //date1.setMinutes(date1.getMinutes()+330);
//     return date1.toLocaleString();

// }

// const dateFormate4 = (dateObject) => {
//     if (!dateObject || dateObject == "0001-01-01T00:00:00" || d != "Invalid Date") {
//         var date = "";
//         if (!dateObject) {
//             var today = new Date();
//             var dd = today.getDate();
//             var mm = today.getMonth() + 1; //January is 0!
//             var yyyy = today.getFullYear();

//             if (dd < 10) {
//                 dd = '0' + dd
//             }

//             if (mm < 10) {
//                 mm = '0' + mm
//             }

//             date = dd + '-' + mm + '-' + yyyy;
//         }
//         return date;
//     }

//     var d = new Date(dateObject);
//     if (d != "Invalid Date") {
//         var day = d.getDate();
//         var month = d.getMonth() + 1;
//         var year = d.getFullYear();
//         if (day < 10) {
//             day = "0" + day;
//         }
//         if (month < 10) {
//             month = "0" + month;
//         }
//          date = year + "-" + month + "-" + day;

//         return date;
//     }
//     return "";

// }

// const dateFormate2 = (dateObject) => {
//     if (!dateObject || dateObject == "0001-01-01T00:00:00") {
//         var date = "";
//         if (!dateObject) {
//             var today = new Date();
//             var dd = today.getDate();
//             var mm = today.getMonth() + 1; //January is 0!
//             var yyyy = today.getFullYear();

//             if (dd < 10) {
//                 dd = '0' + dd
//             }

//             if (mm < 10) {
//                 mm = '0' + mm
//             }

//             date = yyyy + '-' + mm + '-' + dd;
//         }
//         return date;
//     }

//     var d = new Date(dateObject);
//     if (d != "Invalid Date") {
//         var day = d.getDate();
//         var month = d.getMonth() + 1;
//         var year = d.getFullYear();
//         if (day < 10) {
//             day = "0" + day;
//         }
//         if (month < 10) {
//             month = "0" + month;
//         }
//         date = year + "-" + month + "-" + day;

//         return date;
//     }
//     return "";

// }

var dateFormat = (function () {
  var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
    timezone =
      /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
    timezoneClip = /[^-+\dA-Z]/g,
    pad = function (val, len) {
      val = String(val);
      len = len || 2;
      while (val.length < len) val = "0" + val;
      return val;
    };

  // Regexes and supporting functions are cached through closure
  return function (date, mask, utc) {
    var dF = dateFormat;

    // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
    if (
      arguments.length == 1 &&
      Object.prototype.toString.call(date) == "[object String]" &&
      !/\d/.test(date)
    ) {
      mask = date;
      date = undefined;
    }

    // Passing date through Date applies Date.parse, if necessary
    date = date ? new Date(date) : new Date();
    if (isNaN(date)) throw SyntaxError("invalid date");

    mask = String(dF.masks[mask] || mask || dF.masks["default"]);

    // Allow setting the utc argument via the mask
    if (mask.slice(0, 4) == "UTC:") {
      mask = mask.slice(4);
      utc = true;
    }

    var _ = utc ? "getUTC" : "get",
      d = date[_ + "Date"](),
      D = date[_ + "Day"](),
      m = date[_ + "Month"](),
      y = date[_ + "FullYear"](),
      H = date[_ + "Hours"](),
      M = date[_ + "Minutes"](),
      s = date[_ + "Seconds"](),
      L = date[_ + "Milliseconds"](),
      o = utc ? 0 : date.getTimezoneOffset(),
      flags = {
        d: d,
        dd: pad(d),
        ddd: dF.i18n.dayNames[D],
        dddd: dF.i18n.dayNames[D + 7],
        m: m + 1,
        mm: pad(m + 1),
        mmm: dF.i18n.monthNames[m],
        mmmm: dF.i18n.monthNames[m + 12],
        yy: String(y).slice(2),
        yyyy: y,
        h: H % 12 || 12,
        hh: pad(H % 12 || 12),
        H: H,
        HH: pad(H),
        M: M,
        MM: pad(M),
        s: s,
        ss: pad(s),
        l: pad(L, 3),
        L: pad(L > 99 ? Math.round(L / 10) : L),
        t: H < 12 ? "a" : "p",
        tt: H < 12 ? "am" : "pm",
        T: H < 12 ? "A" : "P",
        TT: H < 12 ? "AM" : "PM",
        Z: utc
          ? "UTC"
          : (String(date).match(timezone) || [""])
              .pop()
              .replace(timezoneClip, ""),
        o:
          (o > 0 ? "-" : "+") +
          pad(Math.floor(Math.abs(o) / 60) * 100 + (Math.abs(o) % 60), 4),
        S: ["th", "st", "nd", "rd"][
          d % 10 > 3 ? 0 : (((d % 100) - (d % 10) != 10) * d) % 10
        ],
      };

    return mask.replace(token, function ($0) {
      return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
    });
  };
})();

// Some common format strings
dateFormat.masks = {
  default: "ddd mmm dd yyyy HH:MM:ss",
  shortDate: "m/d/yy",
  mediumDate: "mmm d, yyyy",
  longDate: "mmmm d, yyyy",
  fullDate: "dddd, mmmm d, yyyy",
  shortTime: "h:MM TT",
  mediumTime: "h:MM:ss TT",
  longTime: "h:MM:ss TT Z",
  isoDate: "yyyy-mm-dd",
  isoTime: "HH:MM:ss",
  isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
  isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
};

// Internationalization strings
dateFormat.i18n = {
  dayNames: [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  monthNames: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};
